import { Home } from 'views/website/home';
import { Contact } from 'views/website/contact';
import { Pricing } from 'views/website/pricing';
import { Terms } from 'views/website/terms';
import { Privacy } from 'views/website/privacy';
import { Unsubscribe } from '../views/website/unsubscribe';

const website = [
  {
    path: '/',
    view: Home,
    layout: 'home',
    title: 'OnboardList',
  },
  {
    path: '/contact',
    view: Contact,
    layout: 'home',
    title: 'Contact',
  },
  {
    path: '/pricing',
    view: Pricing,
    layout: 'home',
    title: 'Pricing',
  },
  {
    path: '/privacy-policy',
    view: Privacy,
    layout: 'page',
    title: 'Privacy Policy',
  },
  {
    path: '/terms-of-service',
    view: Terms,
    layout: 'page',
    title: 'Terms of Service',
  },
  {
    path: '/unsubscribe',
    view: Unsubscribe,
    layout: 'page',
    title: 'Unsubscribe',
  },
];

export default website;
